import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PolicyPage from './pages/PolicyPage';
import DocumentViewer from './pages/DocumentViewer';

function App() {
  // ===== Set Page Title =====
  useEffect(() => {
    document.title = 'HR Policy Review System';
  }, []);

  // ===== Disable Right-Click Globally =====
  useEffect(() => {
    const disableRightClick = (e) => {
      e.preventDefault(); // Block right-click
    };

    // Optional: Block F12, Ctrl+U, Ctrl+Shift+I
    const disableKeys = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && e.key === "I") ||
        (e.ctrlKey && e.key === "U")
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", disableRightClick);
    document.addEventListener("keydown", disableKeys);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableKeys);
    };
  }, []);

  return (
    <Router>
      <Routes>
        {/* Main policy page via encrypted employee ID */}
        <Route path="/policy/:encryptedId" element={<PolicyPage />} />
        
        {/* Document viewer via encrypted employee ID and document ID */}
        <Route path="/policy/:encryptedId/document/:docId" element={<DocumentViewer />} />
        
        {/* Redirect all other routes */}
        <Route path="/" element={<Navigate to="/policy/invalid" replace />} />
        <Route path="*" element={<Navigate to="/policy/invalid" replace />} />
      </Routes>
    </Router>
  );
}

export default App;